import { useApi } from "../auth";
import { useEffect, useState } from "react";
import Loading from "./Loading";
import { backend_url } from "../constants";
import Stack from "react-bootstrap/Stack";
import RiskBubble from "./RiskBubble";
import EndpointRankTable from "./EndpointRankTable";
import ExecutingProgress from "./ExecutingProgress";
import { observer } from "mobx-react-lite";

function Endpoints({ store, isPrinting }) {
  let object = store.endpointObject;
  let runObject = store.runObject;

  if (store.loading) return <Loading />;
  if (!object) return <div>Not found</div>;
  if (!object.has_executed) {
    return <ExecutingProgress now={object.execution_progress} />
  }
  let sortedOrgans = Object.keys(object.organ_sensitivities).sort(
    (k1, k2) =>
      object.organ_sensitivities[k2].sensitive /
        object.organ_sensitivities[k2].total -
      object.organ_sensitivities[k1].sensitive /
        object.organ_sensitivities[k1].total
  );
  let sensOrgans = sortedOrgans.slice(0, 5);
  let bubbleClassMap = {
    "High Risk": "high-risk",
    "Medium Risk": "medium-risk",
    "Low Risk": "low-risk",
  }
  let experimentObject = store.experimentObject;
  if(!experimentObject){
    return <Loading />;
  }
  let trial = experimentObject.initial ? experimentObject : experimentObject.preferred_trial;
  return (
    <Stack className="endpoint-container" direction={isPrinting? "vertical": "horizontal"} gap={1}>
      <div className="target-organs">
        <h4>Target Organs</h4>
        <p>Most sensitive organs identified</p>
        <Stack className="target-organ-container" gap={3}>
            {sensOrgans.map(o=>{let risk_level = object.organ_sensitivities[o]['risk_level'];
                return <div className="target-organ-row">
                {o} <RiskBubble text={risk_level} styleClass={bubbleClassMap[risk_level]} />
            </div>})}
        </Stack>
      </div>
      <div className="endpoint-ranks">
        <h4>Endpoint Sensitivity Ranking</h4>
        <p>Ranked by predicted sensitivity score (0-1). Click a row to see the simulated study range</p>
        <EndpointRankTable endpoints={object.endpoint_ranks} doses={trial.doses} doseUnit={runObject.dose_unit} />
      </div>
    </Stack>
  );
}

export default observer(Endpoints);
